import React from "react";
import PropTypes from "prop-types";
import { Paper, Popper } from "@material-ui/core";
import { DocumentPreviewContent } from "./DocumentPreviewContent";

const ResumeHoverPreview = ({
  open,
  anchorEl,
  applicant,
  onClose,
  onOpenFull,
  onMouseEnter,
  onMouseLeave,
}) => {
  const resumeUrl = applicant?.resume || "";
  const resumeName = applicant?.resumeName || "Resume";
  const applicantName = applicant
    ? `${applicant.first_name || ""} ${applicant.last_name || ""}`.trim()
    : "";

  const handlePreviewClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!resumeUrl) {
      return;
    }
    onOpenFull(resumeUrl, resumeName);
    onClose();
  };

  return (
    <Popper
      open={open && Boolean(anchorEl)}
      anchorEl={anchorEl}
      placement="bottom-start"
      className="resume-hover-preview-popper"
      modifiers={{
        offset: { offset: "0, 8" },
        preventOverflow: {
          enabled: true,
          boundariesElement: "viewport",
        },
        flip: { enabled: true },
      }}
    >
      <Paper
        elevation={8}
        className={`resume-hover-preview ${
          resumeUrl ? "resume-hover-preview__panel--clickable" : ""
        }`}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={resumeUrl ? handlePreviewClick : undefined}
        onKeyDown={
          resumeUrl
            ? (event) => {
                if (event.key === "Enter" || event.key === " ") {
                  handlePreviewClick(event);
                }
              }
            : undefined
        }
        role={resumeUrl ? "button" : undefined}
        tabIndex={resumeUrl ? 0 : -1}
      >
        <div className="resume-hover-preview__header">
          <span className="resume-hover-preview__title">
            {applicantName || "Applicant CV"}
          </span>
        </div>

        {resumeUrl ? (
          <>
            <div className="resume-hover-preview__body">
              <DocumentPreviewContent
                documentUrl={resumeUrl}
                documentName={resumeName}
                enabled={open && Boolean(resumeUrl)}
                compact
                showDownload={false}
              />
            </div>
            <div className="resume-hover-preview__hint">
              Click to view full CV
            </div>
          </>
        ) : (
          <div className="resume-hover-preview__placeholder">
            No resume uploaded
          </div>
        )}
      </Paper>
    </Popper>
  );
};

ResumeHoverPreview.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  applicant: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onOpenFull: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

ResumeHoverPreview.defaultProps = {
  anchorEl: null,
  applicant: null,
  onMouseEnter: undefined,
  onMouseLeave: undefined,
};

export default ResumeHoverPreview;
